import { createRoute, redirect } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../route';
import paths from '../../../paths';

export const Route = createRoute({
  path: paths.authenticated.memoryBankNotes,
  getParentRoute: () => pathlessAuthenticatedRoute,
  beforeLoad: () => {
    throw redirect({ to: '/settings/organization/memory-bank-notes' });
  },
});
